<template>
  <div id="reset-password-form">
    <h5 class="title is-5 has-text-centered">
      Reset Password
    </h5>
    <form
      v-if="!isResetPasswordEmailSent"
      @submit.prevent="validateBeforeSubmit()"
    >
      <div class="field">
        <label class="label">Email</label>
        <div class="control">
          <input
            v-model="email"
            v-validate="'required'"
            class="input"
            name="email"
            type="text"
          >
          <p class="help is-danger">
            {{ errors.first('email') }}
          </p>
        </div>
      </div>
      <div class="control buttons">
        <button class="button is-rounded is-white has-text-weight-bold" @click.prevent="toggleLoginForm">
          Cancel
        </button>
        <button
          id="reset-password-button"
          type="submit"
          class="button is-rounded is-primary has-text-weight-bold"
          :class="isLoading ? 'is-loading' : ''"
        >
          Reset Password
        </button>
      </div>
    </form>
    <div v-if="isResetPasswordEmailSent">
      <h4 class="title is-4">
        Success!
      </h4>
      <p>We've sent you an email confirmation to reset your password</p>
      <br>
      <button class="button is-rounded is-primary has-text-weight-bold is-fullwidth" @click.prevent="toggleLoginForm">
        Back to Login
      </button>
    </div>
    <div v-if="isResetPasswordEmailError">
      <h4 class="title is-4">
        Uh Oh!
      </h4>
      <p>Looks like something went wrong. <span class="button is-link" @click.prevent="() => isResetPasswordEmailSent = false">Try again.</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordForm',
  data () {
    return {
      email: '',
      isLoading: false,
      isResetPasswordEmailSent: false,
      isResetPasswordEmailError: false
    };
  },
  methods: {
    sendUserPasswordReset () {
      this.isLoading = true;
      this.$store.dispatch('sendPasswordResetEmail', {
        email: this.email
      })
        .then(response => {
          console.log(response);
          this.isLoading = false;
          this.isResetPasswordEmailSent = true;
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          this.isResetPasswordEmailError = true;
        });
    },
    toggleLoginForm () {
      this.$emit('toggleLoginForm', true);
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendUserPasswordReset();
          return;
        }
        console.log('Correct them errors!');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#reset-password-button {
  margin-left: auto;
}
</style>
